<template>
  <router-view />
</template>

<script>
export default {
  name: 'Root',
};
</script>

<style src="./assets/css/index.css" />
